import { render } from "./QuircGeneralTab.vue?vue&type=template&id=50c6b073"
import script from "./QuircGeneralTab.vue?vue&type=script&lang=js"
export * from "./QuircGeneralTab.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__